export function initMenu() {
    const burger = document.querySelector('[data-menu-burger]');

    if (!burger) return;

    const submenusTriggers = Array.from(document.querySelectorAll('[data-menu] .header-container__submenu-btn'));
    const backTriggers = Array.from(document.querySelectorAll('[data-menu] .header-container__back-btn'));
    const submenus = Array.from(document.querySelectorAll('#menu-principal > .menu-item > .sub-menu'));

    function handleMenuToggle(e) {
        const target = e.currentTarget;

        target.querySelector('.header-container__burger__icon').classList.toggle('opened');
        target.parentElement.classList.toggle('opened');
        if (target.parentNode.classList.contains('opened')) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }

    function handleSticky() {
        const scrollPosition = window.scrollY;
        const referenceElementHeight = document.querySelector('[data-menu]').offsetHeight;

        if (scrollPosition > referenceElementHeight) {
            document.querySelector('[data-menu]').classList.add('sticky');
        } else {
            document.querySelector('[data-menu]').classList.remove('sticky');
        }
    }

    function handleSubmenu(e) {
        if (window.innerWidth < 992) {
            e.preventDefault();
            const submenu = e.currentTarget.parentElement.querySelector('.sub-menu');
            submenu.classList.toggle('opened');
        }
    }

    function handleBack(e) {
        if (window.innerWidth < 992) {
            e.preventDefault();
            const submenu = e.currentTarget.parentElement.parentElement;
            submenu.classList.remove('opened');
        }
    }

    function setSubmenuDirection() {
        submenus.forEach(submenu => {
            const right = submenu.getBoundingClientRect().right;
            const childrenSubmenus = Array.from(submenu.querySelectorAll('.sub-menu'));
            let totalWidth = 0;
            childrenSubmenus.forEach(childrenSubmenu => {
                totalWidth += childrenSubmenu.getBoundingClientRect().width;
            })

            if (totalWidth > (window.innerWidth - right)) {
                submenu.classList.add('desktop-inverted');
            } else {
                submenu.classList.remove('desktop-inverted');
            }
        });
    }

    if (submenusTriggers.length) {
        submenusTriggers.forEach(trigger => {
            trigger.addEventListener('click', handleSubmenu);
        })
    }
    if (backTriggers.length) {
        backTriggers.forEach(trigger => {
            trigger.addEventListener('click', handleBack);
        })
    }
    window.addEventListener('scroll', handleSticky);
    handleSticky();
    setSubmenuDirection();
    window.addEventListener('resize', setSubmenuDirection);
    burger.addEventListener('click', handleMenuToggle);
}